import React, { useState } from 'react';
import { Dropdown } from 'reactstrap';


function CDropdown(props) {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen((prevState) => !prevState);

    return (<Dropdown {...props} isOpen={dropdownOpen} toggle={toggle}>
        {props.children}
    </Dropdown>);
}

export default CDropdown;